import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-&é" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "border border-primary mb-10 mt-3" }
const _hoisted_14 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "d-flex float-end" }
const _hoisted_17 = { class: "p-3" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "form-group mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group mb-2" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "col-md-2 mb-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "col-md-12 mt-3" }
const _hoisted_27 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "transfertForm",
        onSubmit: _ctx.addTransfert,
        "validation-schema": _ctx.transfertSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1)),
                _createVNode(_component_Field, {
                  name: "date",
                  type: "datetime-local",
                  value: _ctx.getCurrentDateTime(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "date",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Magasin A "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "magasin1" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.magasin1Options,
                      "track-by": "value",
                      label: "label",
                      object: true,
                      "model-value": _ctx.selectedMagasin1,
                      "onUpdate:modelValue": (val) => { _ctx.selectedMagasin1 = val; handleChange(val); },
                      placeholder: "Sélectionner le magasin"
                    }, null, 8, ["options", "model-value", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "magasin1",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Magasin B "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "magasin2" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    (_openBlock(), _createBlock(_component_Multiselect, {
                      options: _ctx.magasin2OptionsFiltered,
                      "track-by": "value",
                      label: "label",
                      object: true,
                      "model-value": _ctx.selectedMagasin2,
                      "onUpdate:modelValue": (val) => { _ctx.selectedMagasin2 = val; handleChange(val); },
                      placeholder: "Sélectionner le magasin",
                      key: `magasin2-${_ctx.selectedMagasin1?.value || 'empty'}`
                    }, null, 8, ["options", "model-value", "onUpdate:modelValue"]))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "magasin2",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Motif ", -1)),
                _createVNode(_component_Field, {
                  name: "motif",
                  as: "textarea",
                  cols: "12",
                  rows: "6",
                  placeholder: "Entrer les motifs",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_12), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motif",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-5" }, [
                  _createElementVNode("h5", { class: "fs-6 mx-1 text-white" }, "Transfert (s) du produit")
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" })
                ], -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-success",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRowProduit()))
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                      _createTextVNode("Ajouter un produit ")
                    ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row mt-10" }, [
                  _createElementVNode("div", { class: "col-md-4" }, [
                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Produit "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Quantité"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-md-2" }, [
                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                  ]),
                  _createElementVNode("hr", { class: "mt-0" })
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row gy-0",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.produitOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: produit.produit,
                          "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                          placeholder: "Sélectionner le produit",
                          onSelect: ($event: any) => ( _ctx.selectProd(produit.produit, produit))
                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                        (_ctx.validateRowProduit(produit.produit))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Le produit est obligatoire. "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((produit.qtite) = $event),
                          type: "number",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la quantite"
                        }, null, 8, _hoisted_23), [
                          [_vModelText, produit.qtite]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeRowProduit(index))
                      }, _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                      ]), 8, _hoisted_25)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[11] || (_cache[11] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Faire un transfert ", -1)),
                _createVNode(_component_router_link, {
                  to: "/transferts/liste-transferts",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}